import { createAction, props } from '@ngrx/store';
import { IUpdateMemberDetailRequest, IUpdateMemberDetailResponse } from '../models/member-detail.model';

export const updateMemberDetail = createAction(
  '[Member] Update Member Detail',
  props<{ customerId: string; request: IUpdateMemberDetailRequest }>()
);

export const updateMemberDetailSuccess = createAction(
  '[Member] Update Member Detail Success',
  props<{ response: IUpdateMemberDetailResponse }>()
);

export const updateMemberDetailFailure = createAction(
  '[Member] Update Member Detail Failure',
  props<{ error: any }>()
);